import React, { useCallback } from 'react';
import InputDuration from "../../../../../../../components/Basic/InputDuration";
import { TREATMENT_TYPE } from "../../../../../../../util/varibles/constants";
import { ISorting } from "../../../../../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../../../../../util/varibles/message";
import { IPropsTask } from "../Combine";
import Sorting from "./Sorting";
import styles from "./style.module.scss";

interface IProps extends IPropsTask {
}

const Treatment: React.FC<IProps> = ({ data, unit, onUpdate }) => {
    const { treatment_type, error } = data;

    const handleChangeDuration = useCallback((value: number) => {
        const { duration, ...args } = error;
        onUpdate({ duration: value, error: args })
    }, [error, onUpdate])

    const handleErrorDuration = useCallback((empty: boolean) => {
        onUpdate({
            error: {
                ...error,
                duration: empty ? notify[NotifyCode.E16]() : notify[NotifyCode.E19]()
            }
        })
    }, [error, onUpdate])

    switch (treatment_type) {
        case TREATMENT_TYPE.HYDROGENPEROXIDE:
        case TREATMENT_TYPE.SALTWATER:
        case TREATMENT_TYPE.SALMOCLEAN:
        case TREATMENT_TYPE.FRESHWATER: {
            return <div className={styles['duration-field']}>
                <InputDuration
                    value={+(data.duration || 0)}
                    className={[styles['input-custom'], 'w-full'].join(' ')}
                    isNotZero
                    disabled={unit.isLock}
                    onChange={handleChangeDuration}
                    onError={handleErrorDuration}
                />
            </div>
        }
        case TREATMENT_TYPE.SORTING: {
            return <Sorting
                data={data as ISorting}
                unit={unit}
                onUpdate={onUpdate}
            />
        }
        default:
            return null
    }
};

export default Treatment;
